export default __webpack_public_path__ + "static/media/Path2254.8b06cd5d.svg";